"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DollarIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2 1a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V2a1 1 0 00-1-1H2zm8.25 5c0-.747-.339-1.338-.842-1.722a2.555 2.555 0 00-.908-.433V3a.5.5 0 00-1 0v.76a2.69 2.69 0 00-1.408.518A2.112 2.112 0 005.25 6c0 .769.357 1.313.825 1.692.41.332.93.555 1.337.729l.043.018c.462.199.795.347 1.026.535.188.152.269.295.269.526a.615.615 0 01-.251.528c-.174.133-.443.222-.749.222s-.575-.09-.749-.222A.615.615 0 016.75 9.5a.75.75 0 00-1.5 0c0 .747.339 1.338.842 1.722.413.314.915.477 1.408.518v.76a.5.5 0 001 0v-.845a2.57 2.57 0 00.908-.433c.503-.384.842-.975.842-1.722 0-.769-.357-1.313-.825-1.692-.41-.332-.93-.555-1.337-.729l-.042-.018c-.463-.199-.796-.347-1.027-.535C6.83 6.374 6.75 6.231 6.75 6c0-.253.099-.412.251-.528.174-.133.443-.222.749-.222s.575.09.749.222A.615.615 0 018.75 6a.75.75 0 001.5 0z",
    clipRule: "evenodd"
  })))
});
DollarIcon.displayName = 'DollarIcon';
var _default = exports.default = DollarIcon;